// src/api/publicApi.js
import axios from "axios";

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://proyecto-flamingo-backend.onrender.com",
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // Necesario para que la cookie de sesión viaje también en endpoints mixtos
});

export default publicApi;
